export default {"src":"/_next/static/media/xdn.72983bfd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};